import { sample } from 'effector';
import { orders } from '../../types';
import { $column, $config, setColumn, setOrder, sortToolbarChanged } from '../model';

/** Внешнее событие нажатия на стрелку колонки DataGrid */
export const sortToolbarChangedFunc = () => {
  /** Устанавливаю наименование колонки от внешнего события */
  sample({
    clock: sortToolbarChanged,
    source: { column: $column, config: $config },
    fn: ({ config, column }, params) =>
      params?.[0]?.field ?? (config?.canReset ? null : column),
    target: setColumn,
  });

  /** Устанавливаю направление от внешнего события */
  sample({
    clock: sortToolbarChanged,
    source: $config,
    fn: (config, params) => params?.[0]?.sort ?? (config?.canReset ? null : orders.asc),
    target: setOrder,
  });
};
